// const gatewaysis_serverUrl = 'https://sis.gateway-prime.systems';
const gatewaysis_serverUrl = 'https://gateway-sis.ew.r.appspot.com';
// const gatewaysis_serverUrl = 'http://localhost:8080';

// const gatewaype_serverUrl = 'https://entry.gateway-prime.systems';
const gatewaype_serverUrl = 'https://entry-server-dot-gateway-sis.ew.r.appspot.com';
// const gatewaype_serverUrl = 'http://localhost:8085';

const gatewayspub_serverUrl = 'https://publisher-dot-gateway-sis.ew.r.appspot.com';
// const gatewayspub_serverUrl = 'http://localhost:8090';

export function pingServers(){

  fetch(gatewaysis_serverUrl + '/ping',
    { 
    method: 'GET', 
    headers: {
      // 'content-type': 'application/json',
      'cache-control' : 'no-cache'
    },
  }).catch(err => {
    console.log("Error caught @ GServ.pingServers (gatewaysis) => ",err);
  }); 

  fetch(gatewayspub_serverUrl + '/ping',
  { 
    method: 'GET', 
    headers: {
      // 'content-type': 'application/json',
      'cache-control' : 'no-cache'
    },
  }).catch(err => {
    console.log("Error caught @ GServ.pingServers (publisher) => ",err);
  }); 
  
  fetch(gatewaype_serverUrl + '/ping_from_entry',
    { 
    method: 'GET', 
    headers: {
      // 'content-type': 'application/json',
      'cache-control' : 'no-cache'
    },
  }).catch(err => {
    console.log("Error caught @ GServ.pingServers (entry) => ",err);
  }); 

  return true;
}

export async function prime_email_submit(cToken, email, qparms) {
  const payLoad = JSON.stringify({contact_email:email,q_parms:qparms});
  let submitReply = await fetch(gatewaysis_serverUrl + '/prime_email-submit',
    { 
    method: 'POST', 
    headers: {
      'authentication': cToken,
      'content-type': 'application/json',
      'cache-control' : 'no-cache'
    },
    body: payLoad
  }).then(response => {
    return response.json().then(data => {
      return data;
    });
  })
  .catch(err => {
    console.log("Error caught @ GServ.prime_email_submit => ",err);
    return {Result:"Failed",Message:'Unable to contact Gateway Prime Server'};
  }); 
  return submitReply;
}

export async function generateOTP(gwt, dataObj) {
  const payLoad = JSON.stringify(dataObj);
  let submitReply = await fetch(gatewaysis_serverUrl + '/request_otp',
    { 
    method: 'POST', 
    headers: {
      'authentication': gwt,
      'content-type': 'application/json',
      'cache-control' : 'no-cache'
    },
    body: payLoad
  }).then(response => {
    return response.json().then(data => {
      return data;
    });
  })
  .catch(err => {
    console.log("Error caught @ GServ.requestOTP => ",err);
    return {Result:"Failed",Message:'Unable to contact Gateway Prime Server'};
  }); 
  return submitReply;
}

export async function submitOTP(gwt, Otp) {
  const payLoad = JSON.stringify({otp:Otp});
  let submitReply = await fetch(gatewaysis_serverUrl + '/otp_submission',
    { 
    method: 'POST', 
    headers: {
      'authentication': gwt,
      'content-type': 'application/json',
      'cache-control' : 'no-cache'
    },
    body: payLoad
  }).then(response => {
    return response.json().then(data => {
      return data;
    });
  })
  .catch(err => {
    console.log("Error caught @ GServ.submitOTP => ",err);
    return {Result:"Failed",Message:'Unable to contact Gateway Prime Server'};
  }); 
  return submitReply;
}

export async function submitMobileOTP(gwt, dataObj) {
  const payLoad = JSON.stringify(dataObj);
  let submitReply = await fetch(gatewaysis_serverUrl + '/otp_submission',
    { 
    method: 'POST', 
    headers: {
      'authentication': gwt,
      'content-type': 'application/json',
      'cache-control' : 'no-cache'
    },
    body: payLoad
  }).then(response => {
    return response.json().then(data => {
      return data;
    });
  })
  .catch(err => {
    console.log("Error caught @ GServ.submitMobileOTP => ",err);
    return {Result:"Failed",Message:'Unable to contact Gateway Prime Server'};
  }); 
  return submitReply;
}

export async function authenticateMe(idToken) {
    let authReply = await fetch(gatewaysis_serverUrl + '/authenticate',
      { 
      method: 'GET', 
      headers: {
        'authentication': idToken,
        'content-type': 'application/json',
        'cache-control' : 'no-cache'
      }
    }).then(response => {
      return response.json().then(data => {
        return data;
      });
    })
    .catch(err => {
      console.log("Error caught @ GServ.authenticateMe => ",err);
      return {Result:"Failed",Message:'Unable to contact Gateway Prime ID Server'};
    }); 
    return authReply;
}

export async function id_obj_submit(gwt, dataObj) {
  const payLoad = JSON.stringify(dataObj);
  let submitReply = await fetch(gatewaysis_serverUrl + '/id_obj-submit',
    { 
    method: 'POST', 
    headers: {
      'authentication': gwt,
      'content-type': 'application/json',
      'cache-control' : 'no-cache'
    },
    body: payLoad
  }).then(response => {
    return response.json().then(data => {
      return data;
    });
  })
  .catch(err => {
    console.log("Error caught @ GServ.name_num_submit => ",err);
    return {Result:"Failed",Message:'Unable to contact Gateway Prime Server'};
  }); 
  return submitReply;
}

export async function turn_key(token) {
  let submitReply = await fetch(gatewaysis_serverUrl + '/token_gate',
    { 
    method: 'POST', 
    headers: {
      'authentication': token,
      'content-type': 'application/json',
      'cache-control' : 'no-cache'
    },
  }).then(response => {
    return response.json().then(data => {
      return data;
    });
  })
  .catch(err => {
    console.log("Error caught @ GServ.turn_key => ",err);
    return {Result:"Failed",Message:'Unable to contact Gateway Prime Server'};
  }); 
  return submitReply;
}

export async function logIDAttempt(gwt, dataObj) {
  const payLoad = JSON.stringify(dataObj);
  let submitReply = await fetch(gatewaysis_serverUrl + '/id_attempt_log',
    { 
    method: 'POST', 
    headers: {
      'authentication': gwt,
      'content-type': 'application/json',
      'cache-control' : 'no-cache'
    },
    body: payLoad
  }).then(response => {
    return response.json().then(data => {
      return data;
    });
  })
  .catch(err => {
    console.log("Error caught @ GServ.logIDattempt => ",err);
    return {Result:"Failed",Message:'Unable to contact Gateway Prime Server'};
  }); 
  return submitReply;
}

export async function remove_partial_user(gwt) {
  let submitReply = await fetch(gatewaysis_serverUrl + '/remove_partial_user',
    { 
    method: 'POST', 
    headers: {
      'authentication': gwt,
      'content-type': 'application/json',
      'cache-control' : 'no-cache'
    },
    // body: payLoad
  }).then(response => {
    return response.json().then(data => {
      return data;
    });
  })
  .catch(err => {
    console.log("Error caught @ GServ.remove_partial_user => ",err);
    return {Result:"Failed",Message:'Unable to contact Gateway Prime Server'};
  }); 
  return submitReply;
}

export async function get_app_status(gwt) {
  // console.log('Calling get_app_status...');

  let submitReply = await fetch(gatewaysis_serverUrl + '/get_app_status',
    { 
    method: 'GET', 
    headers: {
      'authentication': gwt,
      'content-type': 'application/json',
      'cache-control' : 'no-cache'
    },
    // body: payLoad
  }).then(response => {
    return response.json().then(data => {
      return data;
    });
  })
  .catch(err => {
    console.log("Error caught @ GServ.get_app_status => ",err);
    return {Result:"Failed",Message:'Unable to contact Gateway Prime Server'};
  }); 
  return submitReply;
}

export async function fetch_final_obj(gwt) {
  // console.log('Calling fetch_final_obj...');

  let submitReply = await fetch(gatewaysis_serverUrl + '/fetch_final_obj',
    { 
    method: 'GET', 
    headers: {
      'authentication': gwt,
      'content-type': 'application/json',
      'cache-control' : 'no-cache'
    },
    // body: payLoad
  }).then(response => {
    return response.json().then(data => {
      return data;
    });
  })
  .catch(err => {
    console.log("Error caught @ GServ.fetch_final_obj => ",err);
    return {Result:"Failed",Message:'Unable to contact Gateway Prime Server'};
  }); 
  return submitReply;
}


export async function requestMobileOTP(gwt,dataObj) {
  const payLoad = JSON.stringify(dataObj);
  let submitReply = await fetch(gatewaysis_serverUrl + '/request_mobile_otp',
    { 
    method: 'POST', 
    headers: {
      'authentication': gwt,
      'content-type': 'application/json',
      'cache-control' : 'no-cache'
    },
    body: payLoad
  }).then(response => {
    return response.json().then(data => {
      return data;
    });
  })
  .catch(err => {
    console.log("Error caught @ GServ.requestMobileOTP => ",err);
    return {Result:"Failed",Message:'Unable to contact Gateway Prime Server'};
  }); 
  return submitReply;
}

export async function confirmReceipt(gwt, entryId) {
  const payLoad = JSON.stringify({entryId:entryId});
  let submitReply = await fetch(gatewaysis_serverUrl + '/confirm_receipt',
    { 
    method: 'POST', 
    headers: {
      'authentication': gwt,
      'content-type': 'application/json',
      'cache-control' : 'no-cache'
    },
    body: payLoad
  }).then(response => {
    return response.json().then(data => {
      return data;
    });
  })
  .catch(err => {
    console.log("Error caught @ GServ.confirmReceipt => ",err);
    return {Result:"Failed",Message:'Unable to contact Gateway Prime Server'};
  }); 
  return submitReply;
}

export async function autoRegister(gwt, entryId) {
  const payLoad = JSON.stringify({entryId:entryId});
  let submitReply = await fetch(gatewaype_serverUrl + '/auto_register',
    { 
    method: 'POST', 
    headers: {
      'authentication': gwt,
      'content-type': 'application/json',
      'cache-control' : 'no-cache'
    },
    body: payLoad
  }).then(response => {
    return response.json().then(data => {
      return data;
    });
  })
  .catch(err => {
    console.log("Error caught @ GServ.autoRegister => ",err);
    return {Result:"Failed",Message:'Unable to contact Gateway Prime Server'};
  }); 
  return submitReply;
}

export async function markAsPaid(gwt, entryId) {
  const payLoad = JSON.stringify({entryId:entryId});
  let submitReply = await fetch(gatewaype_serverUrl + '/mark_as_paid',
    { 
    method: 'POST', 
    headers: {
      'authentication': gwt,
      'content-type': 'application/json',
      'cache-control' : 'no-cache'
    },
    body: payLoad
  }).then(response => {
    return response.json().then(data => {
      return data;
    });
  })
  .catch(err => {
    console.log("Error caught @ GServ.autoRegister => ",err);
    return {Result:"Failed",Message:'Unable to contact Gateway Prime Server'};
  }); 
  return submitReply;
}

export function maskEmail(emailStr){
  var result = "";
  const atPos = emailStr.search("@");
  // console.log(atPos);
  result = emailStr.substring(0,3);
  for (var i = 1; i < atPos; i++) {
    result += "*";
  }
  result += emailStr.substring(atPos,atPos + 4);
  for (var j = atPos+4; j < emailStr.length; j++) {
    result += "*";
  }
  return result;
}

export function maskMobile(mobileStr){
  var result = "";
  // result = mobileStr.substring(0,1);
  for (var i = 0; i < (mobileStr.length-4); i++) {
    result += "*";
  }
  result += mobileStr.substring(mobileStr.length-4,mobileStr.length);
  return result;
}